import { omit } from 'lodash';
import { ACTION_TYPES as TASKS_ACTION_TYPES } from '../tasks/constants';
import { ACTION_TYPES } from './constants';

const projectsReducer = (state = {}, action) => {
  switch (action.type) {
    case TASKS_ACTION_TYPES.GET_TASK_BY_IDENTIFIER_REQUEST_SUCCESS:
      return {
        ...state,
        ...action?.payload?.taskProjects,
      };
    case ACTION_TYPES.GET_USER_PROJECTS_REQUEST_SUCCESS: {
      const updatedPartOfState = (action?.payload || {}).reduce((result, project) => ({
        ...result,
        [project?._id]: {
          ...(state?.[project?._id] || {}),
          ...project
        }
      }), {});

      return {
        ...state,
        ...updatedPartOfState
      };
    }
    case ACTION_TYPES.UPDATE_PROJECT_REQUEST_SUCCESS: {
      const existing = state?.[action?.payload?._id] || {};
      return {
        ...state,
        [action?.payload?._id]: {
          ...existing,
          ...action?.payload,
          sections: existing.sections || action?.payload?.sections,
        }
      };
    }
    case ACTION_TYPES.ADD_PROJECT_REQUEST_SUCCESS: {
      return {
        ...state,
        [action?.payload?._id]: action?.payload || {}
      };
    }
    case ACTION_TYPES.DELETE_PROJECT_REQUEST_SUCCESS: {
      return omit(state, action?.payload);
    }
    case ACTION_TYPES.GET_PROJECT_BY_ID_BASIC_FIELDS_REQUEST_SUCCESS:
      return {
        ...state,
        ...(action.payload?.projects || {}),
      };
    default: {
      return state;
    }
  }
};

export default projectsReducer;
